module.exports = __webpack_public_path__ + "img/salty-1.e78b8b56.webp";